import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';
import * as payloads from 'utils/api/payloads/microApi';
import { ICalculateInstallemntRequest } from '../models/vouchers/calculateInstallment';
import { BillingType } from 'utils/api/models/accounts/singleAccount';

const microApi = () => new RxQuery('microAPI');

export const getOrderStatus = (accountNo: string, crNo: string, msisdn: string) => {
	return microApi()
		.setEndpoint(endpoints.microApi.orderTrackingStatus.getOrderStatus(accountNo, crNo, msisdn))
		.setType('orderStatus')
		.setInvalidateKey('getOrderStatus')
		.disableCache();
};

export const createLoyaltyGroup = (data: payloads.CreateUpdateLoyaltyGroupData) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.createLoyaltyGroup)
		.setPayload(data)
		.setType('createUpdateLoyaltyResponse')
		.disableCache();
};

export const getLoyaltyGroups = (upId: number | null) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.getLoyaltyGroups.getLoyaltyGroups(upId))
		.setInvalidateKey('getLoyaltyGroups')
		.setType('loyaltyGroups')
		.disableCache();
};

export const getLoyaltyGroupDetails = (groupId: number) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.getLoyaltyGroupDetails.getLoyaltyGroupDetails(groupId))
		.setType('loyaltyGroupDetails')
		.disableCache();
};

export const updateLoyaltyGroup = (groupId: number, data: payloads.CreateUpdateLoyaltyGroupData) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.updateLoyaltyGroup.updateLoyaltyGroup(groupId))
		.setPayload(data)
		.setType('createUpdateLoyaltyResponse')
		.disableCache();
};

export const deleteLoyaltyGroup = (groupId: number) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.deleteLoyaltyGroup.deleteLoyaltyGroup(groupId))
		.disableCache();
};

export const unsubscribeSubscription = (subscriptionId: number) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.unsubscribeSubscription.unsubscribeSubscription(subscriptionId))
		.disableCache();
};

export const getGroupSubscriptions = (groupId: number) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.getGroupSubscriptions.getGroupSubscriptions(groupId))
		.setType('groupSubscriptions')
		.disableCache();
};

export const getSubscriptionDetails = (subscriptionId: number) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.getSubscriptionDetails.getSubscriptionDetails(subscriptionId))
		.setInvalidateKey('getSubscriptionDetails')
		.setType('subscriptionDetails')
		.disableCache();
};

export const addSubscription = (data: payloads.AddSubscription) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.addSubscription)
		.setPayload(payloads.addSubscription(data))
		.disableCache();
};

export const getAddonsTopUpsSubscriptions = (upId: number | null) => {
	return microApi()
		.setEndpoint(endpoints.microApi.addonTopUps.getSubscriptions(upId))
		.setInvalidateKey('getAddonsTopUpsSubscriptions')
		.setType('subscriptions');
};

export const createOfflinePayment = (data: any) => {
	return microApi()
		.setEndpoint(endpoints.microApi.billingPaymentTrack.createOfflinePayment)
		.setPayload(data)
		.setAutoContentType()
		.setType('offlinePaymentCreate');
};

export const getOfflinePayments = (upId: string | null) => {
	return microApi()
		.setEndpoint(endpoints.microApi.billingPaymentTrack.getOfflinePayments(upId))
		.setInvalidateKey('getOfflinePayments')
		.setType('offlinePayments');
};

export const downloadOfflinePaymentsAttachments = (attachmentId: number) => {
	return microApi()
		.setEndpoint(endpoints.microApi.billingPaymentTrack.downloadAttachment(attachmentId))
		.setResponseType('blob');
};

export const createOsmInteraction = (data: any) => {
	return microApi()
		.setEndpoint(endpoints.microApi.osmInteraction.createOsmInteraction)
		.setPayload(data)
		.disableCache()
		.setAutoContentType();
};

export const getTickets = (upId: number | null) => {
	return microApi()
		.setEndpoint(endpoints.microApi.osmInteraction.getTickets(upId))
		.setInvalidateKey('getTickets')
		.setType('tickets');
};

export const getInteractions = (data: payloads.GetInteractions) => {
	return microApi()
		.setEndpoint(endpoints.microApi.interactions.getInteractions)
		.setPayload(data)
		.setAccept('application/json')
		.setType('activities')
		.disableCache();
};

export const getInteractionsCsv = (data: payloads.GetInteractions) => {
	return microApi()
		.setEndpoint(endpoints.microApi.interactions.getInteractions)
		.setPayload(data)
		.setAccept('text/csv')
		.setResponseType('blob')
		.disableCache();
};

export const getInteractionDetails = (interactionId: number) => {
	return microApi()
		.setEndpoint(endpoints.microApi.interactions.getInteractionDetails(interactionId))
		.setType('interactionDetailsResponse');
};

export const replaceEsim = (data: payloads.EsimData) => {
	return microApi()
		.setEndpoint(endpoints.microApi.resourceInventory.esimReplacement())
		.setHeaders('X-Omt-Channel', 'EBU', 'allowDataReportingHeader')
		.setPayload(data)
		.disableCache();
};

export const sendQrEmail = (data: payloads.EsimQr) => {
	return microApi()
		.setEndpoint(endpoints.microApi.resourceInventory.sendQrEmail())
		.setPayload(data)
		.disableCache();
};

export const getSimDetails = (phoneNumber: string, serialNo?: string | null) => {
	return microApi().setEndpoint(endpoints.microApi.resourceInventory.simDetails(phoneNumber, serialNo));
};

export const submitProductOrder = (data: any) => {
	return microApi()
		.setEndpoint(endpoints.microApi.resourceInventory.submitProductOrder())
		.setPayload(data)
		.disableCache();
};

export const checkIfResourceIsAvailable = (data: string) => {
	return microApi()
		.setEndpoint(endpoints.microApi.resourceInventory.checkIfResourceIsAvailable(data))
		.disableCache();
};

export const getAvailableNumbers = (rowCount: string, numberSearch?: string) => {
	return microApi()
		.setEndpoint(endpoints.microApi.resourceInventory.getAvailableNumbers(rowCount, numberSearch))
		.disableCache()
		.setType('availableNumbers');
};

export const getProductsDetails = (accountId: string, billingType: BillingType) => {
	return microApi()
		.setEndpoint(endpoints.microApi.products.getProductsDetails(accountId, billingType))
		.setType('productsDetails');
};

export const getSmartVoucher = (cr: string, phone: string): RxQuery => {
	return microApi()
		.setEndpoint(endpoints.microApi.vouchers.getSmartVoucher({ cr, phone }))
		.setType('getSmartVoucher');
};

export const calculateInstallment = (request: ICalculateInstallemntRequest): RxQuery => {
	return microApi()
		.setEndpoint(endpoints.microApi.vouchers.calculateInstallment())
		.setType('calculateInstallment')
		.disableCache()
		.setPayload(request);
};

export const getUserRequests = (data: payloads.GetUserRequests) => {
	return microApi()
		.setEndpoint(endpoints.microApi.requests.getUserRequests())
		.setPayload(data);
};

export const updateUserRequest = (data: payloads.UpdateUserRequest) => {
	return microApi()
		.setEndpoint(endpoints.microApi.requests.updateUserRequest())
		.disableCache()
		.setPayload(data);
};

export const changeTariffPlan = (data: payloads.ChangeTariffPlanRequest) => {
	return microApi()
		.setEndpoint(endpoints.microApi.products.changeTariffPlan())
		.disableCache()
		.setPayload(data);
};

export const addSimCard = (type: payloads.SimType, data: payloads.SimDtoRequest) => {
	return microApi()
		.setEndpoint(endpoints.microApi.services.addSimCard(type))
		.setPayload(data)
		.disableCache();
};

export const deleteSimCard = (type: payloads.SimType, data: payloads.SimDtoRequest) => {
	return microApi()
		.setEndpoint(endpoints.microApi.services.deleteSimCard(type))
		.setPayload(data)
		.disableCache();
};

export const replaceSimCard = (type: payloads.SimType, data: payloads.ReplaceSimRequest) => {
	return microApi()
		.setEndpoint(endpoints.microApi.services.replaceSimCard(type))
		.setPayload(data)
		.disableCache();
};

export const getBillingRequest = () => {
	return microApi()
		.setEndpoint(endpoints.microApi.bills.getBillingRequest())
		.disableCache();
};

export const createBillingRequest = (data: payloads.CreateBillingRequest) => {
	return microApi()
		.setEndpoint(endpoints.microApi.bills.createBillingRequest())
		.setPayload(data)
		.disableCache();
};

export const downloadBillingRequest = (data: payloads.CreateBillingRequest) => {
	return microApi()
		.setResponseType('blob')
		.setEndpoint(endpoints.microApi.bills.downloadBillingRequest(data))
		.disableCache();
};

export const unsubscribeNumber = (data: payloads.UnsubscribeNumber) => {
	return microApi()
		.setEndpoint(endpoints.microApi.loyaltyGroups.unsubscribeNumber)
		.setPayload(data)
		.disableCache();
};

export const getDataUsage = (accountNumber: string) => {
	return microApi()
		.setEndpoint(endpoints.microApi.getDataUsage(accountNumber))
		.disableCache()
		.setType('dataUsages');
};

export const getEbillInfo = (billingAccountNumber: string, attributes: string[]) => {
	return microApi()
		.setEndpoint(endpoints.microApi.getEbillInfo)
		.setPayload({ billingAccountNumber, attributes });
};
